
import Api from '@/libs/api'
import qs from 'qs'
import Vue from 'vue'
import Popup from 'vux/src/components/popup/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

export default {
directives: {
TransferDom
},
components: {
Popup,
XInput,
XSwitch,
XButton,
Tabbar,
TabbarItem,
Actionsheet,
Divider,
Flexbox,
FlexboxItem
},
data() {
return {
noMore: false,
items: [],
page: 0,
pageSize: 5,
keyword: '',
menus: {
menuSearch: '搜索图片',
menuLogout: '退出登录'
},
showMenus: false,
showSearch: false
}
},
mounted: function() {},
methods: {
setShippingCode(promotionID, openid, shippingCode) {
let err = ''
if (!shippingCode) {
err = '快递单号必须填写'
}
if (err) {
Vue.$vux.toast.show({
text: err,
position: 'middle',
type: 'warn'
})
return
}
let params = {
promotion_id: promotionID,
openid: openid,
shipping_code: shippingCode
}
Api.http
.post(Api.url.setPromotionShippingCode, params)
.then(function(result) {
if (result.code === 0) {
Vue.$vux.toast.show({
text: '快递单号设置成功',
position: 'middle',
type: 'success'
})
} else {
Vue.$vux.alert.show({
title: '魔猴网 - 错误提示',
content: result.msg
})
}
})
.catch(function(message) {})
},
clickActionsheet(key) {
if (key === 'menuSearch') {
this.showSearch = true
}
},
handleSearch() {
this.showSearch = false
this.refresh()
},
refresh() {
this.page = 1
this.noMore = false
this.getData()
},
infinite: function(done) {
if (this.noMore) {
done(true)
this.$refs.item_scroller.finishInfinite(true)
} else {
this.page++
var that = this
that.getData(done)
}
},

getData(done) {
var that = this
let params = qs.stringify({
member_token: this.$store.state.member_token,
curpage: this.page
})
Api.http
.get(Api.url.getPromotionUsers + '?' + params)
.then(function(result) {
if (result.flg) {
for (let idata = 0; idata < result.items.length; idata++) {}
if (that.page === 1) {
that.items = result.items
} else {
that.items = that.items.concat(result.items)
}

if (typeof done !== 'function') {
that.$refs.item_scroller.finishPullToRefresh()
}
if (result.totalPageCount <= that.page) {

that.noMore = true

if (typeof done === 'function') {
done(true)
this.$refs.item_scroller.finishInfinite(true)
}
} else {
that.noMore = false

if (typeof done === 'function') {
done()
}
}
}
})
.catch(function(message) {})
}
}
}



// WEBPACK FOOTER //
// ./src/components/PromotionUsers.vue